import { render, staticRenderFns } from "./EntryContentDiff.vue?vue&type=template&id=167e42f9&scoped=true&"
import script from "./EntryContentDiff.vue?vue&type=script&lang=js&"
export * from "./EntryContentDiff.vue?vue&type=script&lang=js&"
import style0 from "./EntryContentDiff.vue?vue&type=style&index=0&id=167e42f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e42f9",
  null
  
)

export default component.exports